export const ICONS = {
  logo: require("../assets/icons/logo.png"),
  classic: require("../assets/images/Quotes/templates/Classic.png"),
  modern: require("../assets/images/Quotes/templates/Redmond.png"),
  elegant: require("../assets/images/Quotes/templates/Clean.png"),
  quote_blank_template1: require("../assets/images/PDF/quote_blank_template1.png"),
  quote_blank_template2: require("../assets/images/PDF/quote_blank_template2.png"),
  quote_blank_template3: require("../assets/images/PDF/quote_blank_template3.png"),
};
